import api from "../api/axios"

export function getAccessibleGyms() {
  return api.get("/gyms").then((r) => r.data)
}

export function createGym(payload) {
  return api.post("/gyms", payload).then((r) => r.data)
}

export function getGymProfile() {
  return api.get("/gyms/profile").then((r) => r.data)
}

export function updateGymProfile(payload) {
  return api.put("/gyms/profile", payload).then((r) => r.data)
}

export function switchGym(gymId) {
  return api.post("/auth/switch-gym", { gymId }).then((r) => r.data)
}
